import { authPostDataRequest } from "./auth-post-data-request";
import { config } from "./config";
import { fetchHandler } from "./fetchHandler";
import { ApiResponse } from "./service.dashboard";

export const cleaningService = {
  getCleaningSetup,
  createLocation,
  createEquipment,
  createTask,
  getRecords,
  loadEquipment,
  loadTasks,
  createLog,
};

function getCleaningSetup(): Promise<ILocationResponse[]> {
  return fetchHandler(`${config.apiUrl}/Cleaning/GetCleaningSetup`, authPostDataRequest({}))
    .then((results) => { return results; });
}

function createLocation(name: string, description: string): Promise<ApiResponse[]> {
  return fetchHandler(`${config.apiUrl}/Cleaning/CreateLocation`, authPostDataRequest({ name, description }))
    .then((result) => { return result; });
}

function createEquipment(locationId: number, name: string, description: string): Promise<ApiResponse[]> {
  return fetchHandler(`${config.apiUrl}/Cleaning/CreateEquipment`, authPostDataRequest({ locationId, name, description }))
    .then((result) => { return result; });
}

function createTask(equipmentId: number, task: string, description: string, frequency: string | null): Promise<ApiResponse[]> {
  return fetchHandler(`${config.apiUrl}/Cleaning/CreateTask`, authPostDataRequest({ equipmentId, task, description, frequency }))
    .then((result) => { return result; });
}

function createLog(userPin: string, taskId: number, notes: string | null): Promise<ApiResponse[]> {
  return fetchHandler(`${config.apiUrl}/Cleaning/CreateLog`, authPostDataRequest({ userPin, taskId, notes }))
    .then((result) => { return result; });
}

function getRecords(): Promise<any[]> {
  return fetchHandler(`${config.apiUrl}/Cleaning/Records`, authPostDataRequest({}))
    .then((results) => { return results; });
}

function loadEquipment(): Promise<any[]> {
  return fetchHandler(`${config.apiUrl}/Cleaning/LoadEquipment`, authPostDataRequest({}))
    .then((results) => { return results; });
}

function loadTasks(equipmentId: number): Promise<any[]> {
  return fetchHandler(`${config.apiUrl}/Cleaning/LoadTasks`, authPostDataRequest({ equipmentId }))
    .then((results) => { return results; });
}

interface ILocationResponse {
  cleaningLocationId: number;
  name: string;
  description: string;
  equipment: IEquipmentResponse[];
}

interface IEquipmentResponse {
  cleaningEquipmentId: number;
  cleaningLocationId: number;
  cleaningLocation: string;
  name: string;
  description: string;
  tasks: ICleaningTask[];
}

interface ICleaningTask {
  cleaningTaskId: number;
  cleaningEquipmentId: number;
  cleaningEquipment: string;
  task: string;
  description: string;
  frequency: string | number | null;
  lastCompletedTime: number | null;
  nextScheduleTime: number | null;
}
